<template>
  <vs-popup id="popupCompany" title="업체 정보" :active.sync="showPopup">
    <div>
      <div class="grid-container">
        <input-form label="업체명">
          <ml-input class="w-full" v-model="info.업체명" />
        </input-form>
        <input-form label="대표자">
          <ml-input class="w-full" v-model="info.대표자" />
        </input-form>

        <input-form label="사업자등록번호">
          <ml-input class="w-full" v-model="info.사업자등록번호" />
        </input-form>
        <input-form label="사업자등록증">
          <FileUploaderNoneToken v-model="info.사업자등록증"/>
        </input-form>

        <input-form label="주소">
          <address-field class="w-full" v-model="info.주소" :visible-zip-code="false"/>
        </input-form>
      </div>

      <div class="grid-container mt-4">
        <input-form label="업태">
          <ml-input class="w-full" v-model="info.업태" />
        </input-form>
        <input-form label="업종">
          <ml-input class="w-full" v-model="info.업종" />
        </input-form>

        <input-form label="담당자">
          <ml-input class="w-full" v-model="info.담당자" />
        </input-form>
        <input-form label="연락처">
          <ml-input class="w-full" v-model="info.연락처" />
        </input-form>
      </div>

      <div class="mt-12" style="justify-self: center;">
        <vs-button color="secondary" style="width: 254px" @click="showPopup = false">위 정보로 업체 등록</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import InputForm from "@/views/pages/register/InputForm.vue";
import FileUploaderNoneToken from "@/components/FileUploaderNoneToken.vue";
import AddressField from "@/components/AddressField.vue";

export default {
  name: "PopupCompanyInfo",
  components: {AddressField, FileUploaderNoneToken, InputForm},
  props: {
    value: Boolean,
  },
  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      showPopup: false,
      info: {
        업체명: '',
        대표자: '',
        사업자등록번호: '',
        사업자등록증: {},
        주소: {
          home_zip: '',
          home_address_1: '',
          home_address_2: '',
        },
        업태: '',
        업종: '',
        담당자: '',
        연락처: '',
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}
.grid-item {
  //grid-column: span 2;
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(1, 1fr); /* 한 열로 변경 */
  }
}
</style>

<style lang="scss">
#popupCompany.con-vs-popup {
  z-index: 53000;

  .vs-popup {
    width: 70%;
    height: auto;

    position: relative;
  }
  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}
</style>
